<label class="toggle-switch">
  <input type="checkbox" (change)="onToggleClick()">
  <div class="toggle-switch-background">
    <div class="toggle-switch-handle"></div>
  </div>
</label>

